import { render, staticRenderFns } from "./DeleteHeaderFooter.vue?vue&type=template&id=54de8b7a&scoped=true"
import script from "./DeleteHeaderFooter.vue?vue&type=script&lang=js"
export * from "./DeleteHeaderFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de8b7a",
  null
  
)

export default component.exports